 import React, { useRef, useState, useEffect } from "react";
import { Box, Typography, IconButton, Badge } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useHistory } from "react-router-dom";



export default function QuickAccessBar({ itens, temPendencias, contagens = {} }) {
  const history = useHistory();
  const containerRef = useRef(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const SCROLL_AMOUNT = 260;

  const updateScrollButtons = () => {
    const el = containerRef.current;
    if (!el) return;

    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(
      el.scrollLeft + el.clientWidth < el.scrollWidth - 5
    );
  };

  useEffect(() => {
    updateScrollButtons();
  }, [itens]);

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      {/* ⬅️ SETA ESQUERDA */}
      {canScrollLeft && (
        <IconButton
          onClick={() =>
            containerRef.current.scrollBy({
              left: -SCROLL_AMOUNT,
              behavior: "smooth",
            })
          }
          sx={{
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 1201,
            pointerEvents: "auto",

            background: "#fff",
            boxShadow: 2,
            "&:hover": { background: "#f5f5f5" },
          }}
        >
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>
      )}

      {/* ➡️ SETA DIREITA */}
      {canScrollRight && (
        <IconButton
          onClick={() =>
            containerRef.current.scrollBy({
              left: SCROLL_AMOUNT,
              behavior: "smooth",
            })
          }
          sx={{
            position: "absolute",
            right: 0,
            cursor: "pointer",

            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 1201,
            pointerEvents: "auto",

            background: "#fff",
            boxShadow: 2,
            "&:hover": { background: "#f5f5f5" },
          }}
        >
          <ArrowForwardIosIcon fontSize="small" />
        </IconButton>
      )}

      {/* 🧩 CARROSSEL */}
      <Box
        ref={containerRef}
        onScroll={updateScrollButtons}
        sx={{
          display: "flex",
          gap: 2,
          width: "100%",
          boxSizing: "border-box",
          overflowX: "auto",
          overflowY: "hidden",
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
          pb: 1,
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {itens.map(item => {
          const Icon = item.icon;
          const destacado = item.destaque === true;
          const quantidade = Number(contagens[item.id]) || 0;

          return (
            <Box
              key={item.id}
              onClick={() => history.push(item.path)}
              sx={{
                flex: "0 0 auto",
                width: 80,
                minWidth: 110,
                scrollSnapAlign: "start",
                textAlign: "center",
                p: 0.5,
                borderRadius: 1,
                background: destacado
                  ? "linear-gradient(135deg, #fff8e1 0%, #ffca28 100%)"
                  : "#f5f7fa",
                border: destacado ? "1px solid #f9a825" : "1px solid transparent",
                boxShadow: destacado ? "0 3px 10px rgba(0,0,0,0.16)" : "none",
                cursor: "pointer",
                "&:hover": { background: destacado ? "#ffd54f" : "#e3f2fd" },
              }}
            >
              <IconButton sx={{ color: destacado ? "#0d47a1" : "primary.main" }}>
                {item.badge === "aprovacoes" && temPendencias ? (
                  <Badge color="error" variant="dot">
                    <Icon />
                  </Badge>
                ) : quantidade > 0 ? (
                  <Badge color="error" badgeContent={quantidade} max={99}>
                    <Icon />
                  </Badge>
                ) : (
                  <Icon />
                )}
              </IconButton>

              <Typography
                variant="body2"
                sx={{ mt: 1, color: destacado ? "#0d47a1" : "inherit", fontWeight: destacado ? 800 : 400 }}
              >
                {item.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
